<template>
  <div class="image-field my-4 px-0">
    <h2 v-if="label">{{ label }}</h2>
    <v-row wrap v-if="localImage">
      <v-col cols="12">
        <ImageFieldCard
          :img="localImage"
          @delete="deleteImg"
          :can-move="false"
          :caption="allowCaption"
        />
      </v-col>
    </v-row>
    <UploadWidget @uploaded="updateImage" :disabled="!!localImage" :limit="1" />
  </div>
</template>

<script>
import Lambda from '@/services/Lambda'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import ImageFieldCard from '@/components/ImageFieldCard.vue'
import UploadWidget from './UploadWidget.vue'

export default {
  name: 'ImageField',
  props: {
    img: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    settingName: {
      type: String,
      default: null,
    },
    allowCaption: {
      type: Boolean,
      default: false,
    },
  },
  components: { ImageFieldCard, UploadWidget },
  data() {
    return {
      localImage: null,
    }
  },
  computed: {
    ...mapFields('auth', ['token']),
    ...mapGetters('shop', ['getShopId']),
    theImg: {
      get() {
        return this.img || null
      },
      set(value) {
        if (value !== null) {
          this.$emit('update', JSON.stringify(value))
          this.$emit('dirtied')
        }
      },
    },
  },
  watch: {
    img: {
      handler(img) {
        this.localImage = img
      },
      immediate: true,
    },
    localImage(localImage) {
      if (localImage !== this.img && localImage !== null) {
        this.$emit('update', JSON.stringify(localImage))
        this.$emit('dirtied')
      } else {
        this.$emit('cleaned')
      }
    },
  },
  methods: {
    updateCaption(index, caption) {
      this.theImg.caption = caption
      this.$emit('update', JSON.stringify(this.theImg))
      this.$emit('dirtied')
    }, // updateCaption
    async deleteImg() {
      let public_id = this.localImage.public_id
      let deleted = await Lambda.post(
        'asset_delete',
        {
          public_id,
          settingName: this.settingName,
          token: this.token,
          shopId: this.getShopId,
        },
        { timeout: 10000 }
      )
      if (deleted.status === 200) {
        this.localImage = null
        this.theImg = null
      }
    }, // deleteImg
    updateImage(imageArray) {
      this.localImage = imageArray[0]
    }, // updateImage
  }, // methods
}
</script>
